<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Caixa Estoque</app-titulo>
      <div class="header-buttons">
        <app-botao *ngIf="podeRealizarVenda()" type="primario" class="button"
          text="Nova Venda" icon="assets/add.svg" (click)="openModalNovaVenda()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Vendas de Estoque</div>
        <div class="align-button">
          <form [formGroup]="form" class="table-filters">
            <app-input type="datetime-local" label="Data Início" name="DT_INIC" formControlName="DT_INIC"
              width="100%"></app-input>
            <app-input type="datetime-local" label="Data Fim" name="DT_FIM" formControlName="DT_FIM"
              width="100%"></app-input>
            <app-input type="select" label="Situação" name="FL_CNCL" formControlName="FL_CNCL" width="100%"
              [selectData]="cancelamentoOptions"></app-input>
          </form>
        </div>
      </div>
      <app-tabela *ngIf="!isLoading" [data]="tableData" [columns]="tableColumns"></app-tabela>
      <div class="paginacao">
        <app-paginacao *ngIf="maxPages > 1" [pages]="maxPages" (selectedPage)="mudarPagina($event)"></app-paginacao>
      </div>
      <div *ngIf="caixaId" class="rodape-tabela">
        <h2 class="valor">
          Total do Caixa:
          {{
            valorTotalCaixa.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            })
          }}
        </h2>
      </div>
    </div>
  </div>
  <app-subtitulo *ngIf="!isLoading && !tableData.length">Nenhum registro encontrado.</app-subtitulo>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
